import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "actionProps", "disableAutoFocus"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { ThemeProvider } from '@mui/material/styles';
import DialogActions from '@mui/material/DialogActions';
import { EmbersButton } from '../button/button';
import { EmbersLink } from '../link/link';
import { FOOTER_ROOT_PREFIX, dialogFooterTheme } from './modalStyles';
export var EmbersModalFooter = function EmbersModalFooter(_ref) {
  var className = _ref.className,
    actionProps = _ref.actionProps,
    disableAutoFocus = _ref.disableAutoFocus,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = actionProps || {},
    tertiary = _ref2.tertiary,
    secondary = _ref2.secondary,
    primary = _ref2.primary;
  var focusButtonRef = useRef(null);
  var focusLinkRef = useRef(null);
  useEffect(function () {
    if (!disableAutoFocus) {
      if (focusLinkRef.current) {
        focusLinkRef.current.focus();
      } else if (focusButtonRef.current) {
        focusButtonRef.current.focus();
      }
    }
  }, []);
  var handleTertiaryKeyDown = function handleTertiaryKeyDown(e) {
    if (e.key === ' ' || e.key === 'Enter') {
      var _tertiary$onClick;
      e.stopPropagation();
      tertiary === null || tertiary === void 0 || (_tertiary$onClick = tertiary.onClick) === null || _tertiary$onClick === void 0 || _tertiary$onClick.call(tertiary, e);
    }
  };
  var renderTertiaryButton = function renderTertiaryButton() {
    if (tertiary !== null && tertiary !== void 0 && tertiary.renderCustomComponent) {
      return tertiary.renderCustomComponent();
    }
    if (!(tertiary !== null && tertiary !== void 0 && tertiary.label) || tertiary !== null && tertiary !== void 0 && tertiary.hidden) {
      return;
    }
    return /*#__PURE__*/React.createElement(EmbersLink, _extends({
      ref: focusLinkRef,
      mode: "light",
      onKeyUp: handleTertiaryKeyDown
    }, tertiary), tertiary.label);
  };
  var renderButtons = function renderButtons() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderTertiaryButton(), /*#__PURE__*/React.createElement("div", {
      className: "".concat(FOOTER_ROOT_PREFIX, "-buttons")
    }, !!secondary && !secondary.hidden && /*#__PURE__*/React.createElement(EmbersButton, _extends({
      ref: !tertiary || tertiary.hidden ? focusButtonRef : null,
      drawingStyle: "outlined"
    }, secondary), secondary.label), !!primary && !primary.hidden && /*#__PURE__*/React.createElement(EmbersButton, _extends({
      ref: (!secondary || secondary.hidden) && (!tertiary || tertiary.hidden) ? focusButtonRef : null
    }, primary), primary.label)));
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: dialogFooterTheme
  }, /*#__PURE__*/React.createElement(DialogActions, _extends({
    className: classnames("".concat(FOOTER_ROOT_PREFIX, "-root"), _defineProperty({}, "".concat(FOOTER_ROOT_PREFIX, "-tertiary-wrap"), tertiary === null || tertiary === void 0 ? void 0 : tertiary.label))
  }, props), renderButtons()));
};

// EmbersModalFooter.displayName = 'Embers Modal Footer'